// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var AccountDataSettingsController = function ($scope, $modal, gettext, gettextCatalog, AccountRelatedData, AccountProductData, AccountDemoData, $http, $location, $rootScope) {
    
    var _ProductStatusCtr = getStatusCtr();
    function checkIsSandbox() {
        if (!$rootScope.publicSettings.SandboxInstance) {
            $location.path($rootScope.defaultLocation());
        }
    }

    if (!$rootScope.publicSettings) {
        $scope.$watch("publicSettings", function (newValue, oldValue) {
            checkIsSandbox();
        });
    } else {
        checkIsSandbox();
    }

    $scope.createData = function () {
        $scope.yesCancel(_txt(gettext('Create Demo Data')), _txt(gettext('This will delete all products and customer/contract data and will create a set of demo data instead. Do you want to proceed?')), createDemoData);
    };

    $scope.clearData = function () {
        var modalInstance = $modal.open({
            templateUrl: 'partials/account-settings/account-data-dialog.html' + $scope.linkVersion,
            controller: AccountDataSettingsDialogController,
            windowClass: 'fade in',
            resolve: {}
        });
        modalInstance.result.then(function (selectedItem) {
            var data = selectedItem.data;
            var items = getSelectedItems(data);
            $scope.yesCancel(_txt(gettext('Delete Account Data')), _txt(gettext('This will delete all {0}. Do you want to proceed?')).replace('{0}', items),
                function () {
                    clearDemoData(data);
                });
        }, function () {
        });
    };

    function createDemoData() {
        $scope.startProcess = true;
        $scope.processTitle = _txt(gettext('Create Demo Data'));

        AccountDemoData(function (response) {
            response.data.forEach(function (status) {
                addStatus(status.Name, status.Succeeded);
            })
        });
    }

    function clearDemoData(data) {
        _ProductStatusCtr.clear();
        $scope.startProcess = true;
        $scope.processTitle = _txt(gettext('Clear Account Data'));

        if (data.CustomerRelatedData) {
            clearRelatedData();
        }
        if (data.ProductData) {
            clearProductData();
        }
    }

    function clearRelatedData() {
        AccountRelatedData(
            function (response) {
                response.data.forEach(function (status) {
                    addStatus(status.Name, status.Succeeded);
                })
            },
            //error
            function () {
                addStatus(_txt(gettext('Error while removing Customer and contract data')), false);
            });
    }

    function clearProductData() {

        AccountProductData(function (response) {
                response.data.forEach(function (status) {
                    addStatus(status.Name, status.Succeeded);
                });
            }, //error
            function () {
                addStatus(_txt(gettext('Error while removing product data')), false);
            });
    }

    function getSelectedItems(data) {
        var items = [];
        if (data.ProductData) {
            items.push(_txt(gettext('product data')));
        }
        if (data.CustomerRelatedData) {
            items.push(_txt(gettext('customer and contract data')));
        }
        return items.join(', ');
    }

    function addStatus(name, status) {
        _ProductStatusCtr.add({key: name, succeeded: status});
        $scope.ProductStatus = _ProductStatusCtr.getItems();
    }

    var _txt = function (msg) {
        return gettextCatalog.getString(msg);
    };

    function getStatusCtr() {
        var items = {};
        var arrItem = [];
        return {
            add: function (data) {
                if (data && data.key) {
                    var k = data.key;
                    if (!(k in items)) {
                        var obj = {name: k};
                        items[k] = obj;
                        arrItem.push(obj);
                    }
                    items[k].succeeded = data.succeeded;
                  
                }
            },
            getItems: function () {
                return arrItem;
            },
            clear: function () {
                items = {};
                arrItem = [];
            }
        }
    }
};
AccountDataSettingsController.$inject = ['$scope', '$uibModal', 'gettext', 'gettextCatalog', 'AccountRelatedData', 'AccountProductData', 'AccountDemoData', '$http', '$location', '$rootScope'];
